import type { GroupEntity } from '@group/domain';
import { useTranslation } from 'react-i18next';
import { useCurrentUserEntity } from '@user/UserEntity/useCurrentUserEntity';

type Props = {
  group: Pick<GroupEntity, 'id' | 'name'>;
};

export const BillingSupportPanel: React.FC<Props> = ({ group }: Props) => {
  const { t } = useTranslation();
  const requester = useCurrentUserEntity();
  const getSupportUrl = (): string => {
    const url = new URL('https://balus-help.levii.co.jp/hc/ja/requests/new');
    url.searchParams.set('tf_subject', t('group.billingSupport.subject.title'));
    url.searchParams.set(
      'tf_description',
      t('group.billingSupport.description.message', {
        groupName: group.name.toString(),
        groupId: group.id,
        // Zendeskの説明欄はHTMLとして解釈されるため、テンプレートの<br />を残し、補間値だけエスケープする。
        interpolation: { escapeValue: true },
      })
    );
    if (requester?.mailAddress) url.searchParams.set('tf_anonymous_requester_email', requester.mailAddress);
    if (requester?.name) url.searchParams.set('tf_8030926000665', requester.name);
    return url.toString();
  };

  return (
    <section className="mt-8 rounded border border-gray-300 p-5" aria-labelledby="billing-support-title">
      <h2 id="billing-support-title" className="text-lg font-bold">
        {t('group.billingSupport.title')}
      </h2>
      <p className="mt-2 text-sm leading-6">{t('group.billingSupport.message')}</p>
      <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2 text-sm">
        <a
          href={getSupportUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-700 underline hover:no-underline"
        >
          {t('group.billingSupport.cancel.label')}
        </a>
        <a
          href={getSupportUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-700 underline hover:no-underline"
        >
          {t('group.billingSupport.contact.label')}
        </a>
      </div>
    </section>
  );
};
